export default __webpack_public_path__ + "static/media/chillrx_red_logo.png";